import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface ConversationSummary {
  phone: string;
  status: 'open' | 'resolved' | 'archived';
  assigned_to: string | null;
  unread_count: number;
  last_message_at: number | null;
  /** Which of our numbers this customer last used. Absent on older conversations. */
  last_number_id?: string | null;
  /** The customer's name: a saved contact's, else the one WhatsApp sent us. */
  name?: string | null;
  /** True when `name` comes from a saved contact rather than their profile. */
  name_saved?: boolean;
}

type QueryResponse = {
  status: number;
  data: {
    conversations: ConversationSummary[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListConversationsKey = (additional: any[] = []) => [
  'list-conversations',
  ...additional,
];

export const useListConversationsQuery = (
  additionalProps = {},
  options: { refetchInterval?: number } = {},
) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Conversations',
    endpoint: `/api/admin/whatsapp/conversations`,
  });

  return useQuery({
    queryKey: createListConversationsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
    refetchInterval: options.refetchInterval,
  });
};